import { render, staticRenderFns } from "./PlayerPastBookingRequest.vue?vue&type=template&id=5b2f9525&"
import script from "./PlayerPastBookingRequest.vue?vue&type=script&lang=js&"
export * from "./PlayerPastBookingRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports